import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplateTipoMetadado'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetEquipamentos = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetEquipamentos/${id}`, data, config)
const GetStatusTemplateQMA = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetStatusQMATemplatePerguntasVerificacao`, data, config)

const qmaTemplateMetadataType = {
  GetEquipamentos,
  GetStatusTemplateQMA
}

export default qmaTemplateMetadataType



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplateMetadataType.js